import React from 'react'

import { NarrowFulfilmentMethodInputType, OrderMode } from '@src/graphql-types'
import { CurrentFulfilmentType } from '@src/hooks/outletFulfilmentAndBasketHooks/useOutletFulfilment/validation'
import { useMarketplace } from '@src/hooks/useMarketplace'

import { DeliveryZonePickerModal } from './DeliveryZonePickerModal'
import { PostcodeInputModal } from './PostcodeInputModal'
import { TablePickerModal } from './TablePickerModal'
import {
  OutletFulfilmentStateType,
  useOutletFulfilment,
} from '@src/hooks/outletFulfilmentAndBasketHooks/useOutletFulfilment/useOutletFulfilment'

// modal which is shown if the user has not selected a location or delivery is not available to address
export const LocationRequiredAlert: React.FC<{
  onSelected?: () => void
  narrowFulfilmentMethods?: NarrowFulfilmentMethodInputType[]
  locationError?: boolean
}> = ({
  onSelected = () => void 0,
  narrowFulfilmentMethods,
  locationError = false,
}) => {
  const { orderMode } = useMarketplace()
  const outletFulfilment = useOutletFulfilment({
    stateType: OutletFulfilmentStateType.GLOBAL,
  })

  if (orderMode === OrderMode.LIST) {
    return <DeliveryZonePickerModal onSelected={onSelected} />
  }

  if (orderMode === OrderMode.POSTCODE) {
    if (
      outletFulfilment.data.currentFulfilment.type ===
      CurrentFulfilmentType.TABLE_UNSELECTED
    ) {
      return <TablePickerModal onSelected={onSelected} />
    }

    if (
      [
        CurrentFulfilmentType.DELIVERY_POSTCODE,
        CurrentFulfilmentType.DELIVERY_EVERYWHERE,
      ].includes(outletFulfilment.data.currentFulfilment.type)
    ) {
      return (
        <PostcodeInputModal
          onSelected={onSelected}
          narrowFulfilmentMethods={narrowFulfilmentMethods}
          locationError={locationError}
        />
      )
    }
  }

  return null
}
